import { useEffect, useState } from 'react';
import { isMobileViewport } from '@/utils/viewport';

/** 监听视口宽度，≤768 视为 H5 / 移动端 */
export function useIsMobileViewport(): boolean {
  const [mobile, setMobile] = useState(isMobileViewport);

  useEffect(() => {
    const onResize = () => setMobile(isMobileViewport());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return mobile;
}
